import { snakeCase } from 'lodash-es';

import { EXTENDED_UTM_KEYS } from '@pflegia/types/common/constants/utm-keys';
import { cookieStorage } from '@pflegia/ui/storage/cookie-storage';

import { INITIAL_UTM_TIMESTAMP, LATEST_UTM_TIMESTAMP } from '../constants/utm-keys';

export const removeUtmKeysFromCookies = () => {
  [...EXTENDED_UTM_KEYS, INITIAL_UTM_TIMESTAMP, LATEST_UTM_TIMESTAMP]
    .map(key => snakeCase(key))
    .forEach(utmKey => {
      cookieStorage.removeItem(utmKey);
    });
};
